import CryptoJS from "crypto-js";
import Config from "./Config";

const isJson = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch (error) {
        return false;
    }
};

export const encrypt = (data) => {
    const parsedKey = CryptoJS.enc.Utf8.parse(Config.KEYS.PARSED_KEY);
    const iv = CryptoJS.enc.Utf8.parse(Config.KEYS.IV_KEY);
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), parsedKey, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });
    return { encryptedData: encrypted.toString() };
};

export const decrypt = (data) => {
    try {
        const parsedKey = CryptoJS.enc.Utf8.parse(Config.KEYS.PARSED_KEY);
        const iv = CryptoJS.enc.Utf8.parse(Config.KEYS.IV_KEY);
        const base64 = CryptoJS.enc.Base64.parse(data);
        const src = CryptoJS.enc.Base64.stringify(base64);
        const decrypted = CryptoJS.AES.decrypt(src, parsedKey, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const plain = decrypted.toString(CryptoJS.enc.Utf8);
        if (isJson(plain)) {
            return { success: true, data: JSON.parse(plain) };
        }
        return { success: false };
    } catch (error) {
        return { success: false };
    }
};
